import styled from 'styled-components'

export const Label = styled.label`
	user-select: none;
	display: flex;
	align-items: center;
	margin: 0 20px 0 0;
`

export const SwitchWrapper = styled.span`
	border-radius: 20px;
	cursor: pointer;
	height: 24px;
	float: left;
	overflow: hidden;
	position: relative;
	width: 48px;

	input[type="checkbox"] {
		opacity: 0;
		position: absolute;
	}

	input[type="checkbox"] + .switch {
		transform: translateX(5px);
	}

	input[type="checkbox"]:checked + .switch {
		transform: translateX(50%) translateX(-19px);
	}

	input[type="checkbox"]:checked + .switch {
		transform: translateX(67%) translateX(-35px);
	}

	input[type="checkbox"]:disabled + .switch {
		background: #ccc;
	}

	&.large {
		height: 40px;
		width: 80px;
		.switch {
			.switch-handle {
				height: 30px;
				width: 30px;
			}
		}
	}

	&.large + .switch-label {
		line-height: 4rem;
		margin-left: 15px;
	}

	.switch {
		color: #fff;
		display: inline-block;
		height: 100%;
		left: -100%;
		position: relative;
		transition: 100ms linear;
		width: 200%;
		.switch-handle {
			background: #2d0f19;
			border-radius: 50%;
			display: inline-block;
			height: 14px;
			left: 50%;
			position: relative;
			top: 2px;
			width: 14px;
			z-index: 3;
		}
		&.btn-success {
			background-color: #fff !important;
			border-color: #fff !important;
			&:hover, &:active, &:focus {
				background-color: #fff !important;
				border-color: #fff !important;
			}
		}
		&.btn-danger {
			background-color: #6e6b7b !important;
			border-color: #6e6b7b !important;
			&:hover, &:active, &:focus {
				background-color: #6e6b7b !important;
				border-color: #6e6b7b !important;
			}
		}
	}
`

export const SwitchLabel = styled.span`
	float: left;
	line-height: 1rem;
	margin-left: 10px;
	color: #fff;
`


// WEBPACK FOOTER //
// ./src/components/UI/styled.js